module.exports = __webpack_public_path__ + "media/site_templates/www.fencingcolorbond.net.au/images/about_us-d024de09d9038e92fc8e8c74a114463d.jpg";